import { Icon, Tooltip, colors } from '@dev-spendesk/grapes';

import { useTranslation } from 'common/hooks/useTranslation';

export const PredictionIconTooltip = () => {
  const { t } = useTranslation('global');
  return (
    <Tooltip triggerAsChild content={t('forms.automation.prediction.tip')}>
      <Icon
        name="sparkle"
        color={colors.contentBrandDefault}
        size="m"
        className="mr-4"
      />
    </Tooltip>
  );
};
